var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import AbstractEditable from './abstract';
import { Tooltip } from "AC/plugin/tooltip";
var WPLibraryEditable = /** @class */ (function (_super) {
    __extends(WPLibraryEditable, _super);
    function WPLibraryEditable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WPLibraryEditable.prototype.render = function () {
        this.library = wp.media({
            multiple: this._args.multiple,
            library: this._args.library,
            title: this._args.title
        });
        this.displaySaveButton(false);
        this.currentValues = [];
        this._addEvents();
    };
    WPLibraryEditable.prototype.valueToInput = function (value) {
        if (value) {
            this.currentValues = Array.isArray(value) ? value : [value];
        }
        if (!this._args.showbuttons) {
            this.library.open();
        }
    };
    WPLibraryEditable.prototype.getValue = function () {
        return this.currentValues;
    };
    WPLibraryEditable.prototype.getTemplate = function () {
        return "\n\t\t<a href=\"#\" class=\"wplib button\">Select</a>\n\t\t<div class=\"aceditable__selected\"></div>";
    };
    WPLibraryEditable.prototype._addEvents = function () {
        var _this = this;
        this.getElement().querySelector('.wplib').addEventListener('click', function (e) {
            e.preventDefault();
            _this.library.open();
        });
        this.library.on('open', function () {
            var selection = _this.library.state().get('selection');
            var value = _this.currentValues;
            if (!value || _this._args.disableSelection) {
                return;
            }
            value.forEach(function (id) {
                var attachment = wp.media.attachment(id);
                attachment.fetch();
                selection.add(attachment ? [attachment] : []);
            });
        });
        this.library.on('select', function () {
            var selection = _this.library.state().get('selection').toJSON();
            var ids = [];
            selection.forEach(function (selected) {
                ids.push(selected.id);
            });
            _this.currentValues = _this._args.multiple ? ids : ids[0];
            if (!_this._args.showbuttons) {
                _this.save();
                _this.close();
            }
            _this.SetImagesFromSelection(_this.library.state().get('selection').models);
            _this.displayLibraryButton(false);
            _this.displaySaveButton(true);
        });
        this.library.on('close', function () {
            if (_this._args.showbuttons) {
                return;
            }
            setTimeout(function () {
                _this.close();
            }, 0);
        });
    };
    WPLibraryEditable.prototype.displaySaveButton = function (show) {
        var button = this.getElement().querySelector('.aceditable__form__controls');
        if (show) {
            button.style.display = 'inline-block';
        }
        else {
            button.style.display = 'none';
        }
    };
    WPLibraryEditable.prototype.displayLibraryButton = function (show) {
        if (show === void 0) { show = true; }
        var button = this.getElement().querySelector('.wplib');
        if (show) {
            button.style.display = 'inline-block';
        }
        else {
            button.style.display = 'none';
        }
    };
    WPLibraryEditable.prototype.SetImagesFromSelection = function (models) {
        var _this = this;
        var container = this.getElement().querySelector('.aceditable__selected');
        if (models.length === 0) {
            return;
        }
        models.forEach(function (model) {
            var wrapper = document.createElement('div');
            var element = null;
            switch (model.attributes.type) {
                case 'image':
                    element = WPLibraryEditable.getImageElement(model);
                    break;
                default:
                    element = WPLibraryEditable.getFileElement(model);
            }
            if (!element) {
                return;
            }
            wrapper.append(element);
            wrapper.append(WPLibraryEditable.getInfoElement(model));
            wrapper.classList.add('aceditable__selected__item');
            var content = wrapper.querySelector('.aceditable__selected__item__info').innerHTML;
            new Tooltip(wrapper, content);
            element.addEventListener('click', function (e) {
                e.preventDefault();
                _this.library.open();
            });
            container.append(wrapper);
        });
    };
    WPLibraryEditable.getInfoElement = function (model) {
        var element = document.createElement('div');
        element.classList.add('aceditable__selected__item__info');
        element.innerHTML = "\n\t\t\t<div>" + model.attributes.title + "</div>\n\t\t\t<div>" + model.attributes.filename + "</div>\n\t\t\t<div>ID: " + model.attributes.id + "</div>\n\t\t";
        return element;
    };
    WPLibraryEditable.getImageElement = function (model) {
        var element = document.createElement('img');
        var url = model.attributes.url;
        if (model.attributes.sizes.hasOwnProperty('thumbnail')) {
            url = model.attributes.sizes.thumbnail.url;
        }
        element.setAttribute('src', url);
        element.classList.add('image');
        return element;
    };
    WPLibraryEditable.getFileElement = function (model) {
        var element = document.createElement('img');
        element.setAttribute('src', model.attributes.icon);
        element.classList.add('file');
        return element;
    };
    WPLibraryEditable.prototype._setDefaults = function () {
        this._defaults.type = 'media';
        this._defaults.title = 'Media';
        this._defaults.multiple = true;
        this._defaults.showbuttons = false;
        this._defaults.disableSelection = false;
        this._defaults.library = {
            uploadedTo: true
        };
    };
    return WPLibraryEditable;
}(AbstractEditable));
export default WPLibraryEditable;
